import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
const StudentEvents = () => {
    const [events, setEvents] = useState([]);
    useEffect(() => {
        axios.get("/api/student/get-events-list")
        .then(response => {
            setEvents(response.data);
        })
        .catch(error => {
            console.error("Error fetching events:", error);
        });
    }, []);

    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Events</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        
                        {events.length === 0 ? (
                                <div className="row gy-3 p-10">
                                    <div className="text-center error">No events found</div>
                                </div>
                            ) : (
                                events.map((event, index) => (
                                    <div className="row gy-3 p-10" key={index}>
                                        <div className="col-4 bg-primary p-10 text-center text-white event-section-radius-left">
                                            <div className="h2 p-0">{dayjs(`${event.date}`).format('DD')} {dayjs(`${event.date}`).format('MMM')} {dayjs(`${event.date}`).format('YYYY')}</div>
                                        </div>
                                        <div className="col-8 p-10 event-section event-section-radius-right">
                                            <div className="h5 p-0">{event.event_name}</div>
                                            <span>{dayjs(`${event.date}`).format('dddd')}</span>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    );
};
export default StudentEvents;